<template>
  <div>
    <!-- <HeaderBar :title="hTitle" /> -->
    <div class="fixed top-0 w-full pt-[8px] bg-white">
      <NavBar />
    </div>
    <div>
      <div class="w-[500px] h-auto px-10 top-[75px] mt-[25px] sm:fixed">
        <!-- <a href="#" v-scroll-to="'#class1'">class 1</a> -->
        <div class="w-1/2">
          <v-expansion-panels>
            <ExpansionPanelTitle title="Financing Scheme" />
            <v-expansion-panel v-for="(item, i) in parent" :key="i">
              <v-expansion-panel-header>
                {{ item.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-for="(item, j) in item.child" :key="j">
                  <button
                    v-scroll-to="item.scroll_to"
                    class="
                      w-full
                      hover:text-red-900 hover:bg-gray-200
                      p-2
                      flex
                    "
                  >
                    {{ item.title }}
                  </button>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
      <div class="sm:ml-[250px] sm:px-10 mt-[75px] min-w-[750px]">
        <InHouseFinancingIntro
          class="class1 pt-[25px]"
          :hTitle="'InHouse Financing'"
        />
        <InHouseFinancingDownpayment
          class="class2 pt-[25px]"
          :hTitle="'Downpayment'"
        />
        <InHouseFinancingMonthlyAmort
          class="class3 pt-[25px]"
          :hTitle="'Monthly Amortization'"
        />
        <InHouseFinancingPenalties
          class="class4 pt-[25px]"
          :hTitle="'Penalties'"
        />
      </div>

      <!-- bank financing  -->
      <div class="sm:ml-[250px] sm:px-10 mt-[75px] min-w-[750px]">
        <BankFinancing-Process class="class11 pt-[25px]" :hTitle="'Process'" />
        <BankFinancing-requirements-from-buyer
          class="class22 pt-[25px]"
          :hTitle="'Requirements from Buyer'"
        />
        <BankFinancing-requirements-from-developer
          class="class33 pt-[25px]"
          :hTitle="'Requirements from Developer'"
        />
        <BankFinancing-accredited-banks
          class="class44 pt-[25px]"
          :hTitle="'Accredited Banks'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ExpansionPanelTitle from "../../../components/ExpansionPanelTitle.vue";
import InHouseFinancingDownpayment from "./InHouseFinancing-DownPayment.vue";
import InHouseFinancingIntro from "./InHouseFinancing-Intro.vue";
import InHouseFinancingPenalties from "./InHouseFinancing-Penalties.vue";
import InHouseFinancingMonthlyAmort from "./InHouseFinancing-MonthlyAmort.vue";
import NavBar from "../../../../../common/NavBar-Fixed.vue";
import BankFinancingProcess from "./bank-financing/BankFinancing-Process.vue";
import BankFinancingRequirementsFromBuyer from "./bank-financing/BankFinancing-requirements-from-buyer.vue";
import BankFinancingRequirementsFromDeveloper from "./bank-financing/BankFinancing-requirements-from-developer.vue";
import BankFinancingAccreditedBanks from "./bank-financing/BankFinancing-accredited-banks.vue";

export default {
  components: {
    ExpansionPanelTitle,
    NavBar,
    InHouseFinancingDownpayment,
    InHouseFinancingIntro,
    InHouseFinancingPenalties,
    InHouseFinancingMonthlyAmort,
    BankFinancingProcess,
    BankFinancingRequirementsFromBuyer,
    BankFinancingRequirementsFromDeveloper,
    BankFinancingAccreditedBanks,
  },
  data() {
    return {
      show: false,
      parent: [
        {
          title: "Inhouse Financing",
          id: 1,
          child: [
            {
              title: "Inhouse Financing",
              scroll_to: ".class1",
              id: 2,
            },
            {
              title: "Down Payment",
              scroll_to: ".class2",
              id: 3,
            },
            {
              title: "Monthly Amortization",
              scroll_to: ".class3",
              id: 32,
            },
            {
              title: "Penalties",
              scroll_to: ".class4",
              id: 4,
            },
          ],
        },
        {
          title: "Bank Financing",
          id: 5,
          child: [
            {
              title: "Process",
              scroll_to: ".class11",
              id: 1,
            },
            {
              title: "Requirements from Buyer",
              scroll_to: ".class22",
              id: 2,
            },
            {
              title: "Requirements from Buyer",
              scroll_to: ".class33",
              id: 3,
            },
            {
              title: "Accredited Banks",
              scroll_to: ".class44",
              id: 4,
            },
          ],
        },
      ],
    };
  },
};
</script>
